import React from 'react';
import { ChevronRightIcon } from 'components/icons';
import { classes, RecipientCountsProps, warningMessage } from './constants';

export function RecipientCounts(
  args: RecipientCountsProps,
): React.ReactElement {
  const { counts, announcement } = args;
  const isSent = announcement?.status === 'Sent';
  const hasDeliveryData = announcement?.publishedCount > 0;
  const showDeliveryUnavailable = isSent && !hasDeliveryData;

  const renderCurrentWorkers = (): React.ReactElement => (
    <>
      <div className={classes.header}>Current Workers Matching Filter</div>
      <div className="odin-grid odin-grid-cols-6  odin-w-[400px]">
        <div className={classes.title}>Total Workers</div>
        <div className="odin-col-span-1 odin-row-span-2">
          <ChevronRightIcon className="odin-text-odin-primary odin-text-2xl odin-mt-3 odin-ml-3" />
        </div>
        <div className={classes.title}>With contact info</div>
        <div className={classes.value}>{counts?.totalCount ?? '...'}</div>
        <div className={classes.value}>
          {counts?.totalReachableCount ?? '...'}
        </div>
      </div>
      {!!counts && !counts.totalReachableCount && (
        <div className="odin-col-auto odin-mt-3 odin-text-odin-danger">
          {warningMessage}
        </div>
      )}
    </>
  );

  const renderDeliveryStatus = (): React.ReactElement => (
    <>
      <div className={classes.header}>Delivery Status</div>
      <div className="odin-grid odin-grid-cols-6  odin-w-[400px]">
        <div className={classes.title}>Attempted</div>
        <div className="odin-col-span-1 odin-row-span-2">
          <ChevronRightIcon className="odin-text-odin-primary odin-text-2xl odin-mt-3 odin-ml-3" />
        </div>
        <div className={classes.title}>Delivered</div>
        <div className={classes.value}>{announcement.publishedCount}</div>
        <div className={classes.value}>{announcement.deliveredCount}</div>
      </div>
    </>
  );

  const renderDeliveryStatusUnavailable = (): React.ReactElement => (
    <>
      <div className={classes.header}>Delivery Status</div>
      <div className="odin-grid odin-grid-cols-2 odin-w-[400px]">
        <div className={classes.value}>Unavailable</div>
      </div>
    </>
  );

  return (
    <div className={classes.recipientCountsContainer}>
      <div className="odin-container">
        {!isSent && renderCurrentWorkers()}
        {isSent &&
          (showDeliveryUnavailable
            ? renderDeliveryStatusUnavailable()
            : renderDeliveryStatus())}
      </div>
    </div>
  );
}
